var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 31.25H12v-2.083h11.542q2.916 0 5.062-1.917 2.146-1.917 2.146-4.792t-2.146-4.791q-2.146-1.917-5.062-1.917H11.167l4.958 4.958-1.5 1.5-7.458-7.5 7.458-7.458 1.5 1.458-4.958 4.959H23.5q3.833 0 6.583 2.521 2.75 2.52 2.75 6.27 0 3.75-2.75 6.271T23.5 31.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.ebb3bf65707f63360139234038aa9326.svg";
export { ForwardRef as ReactComponent };